<div class="timeline-record">
    <div class="timeline-header">
        <div class="timeline-datetime">
            {{ record.date }} | {{ record.time }}
        </div>
    </div>

    <!-- Main Content -->
    <div class="timeline-content">
        <!-- Type Icon and Title -->
        <div class="timeline-main">
            <div class="type-icon">
                <img [src]="getTypeIcon(record.type)" [alt]="record.type" />
            </div>
            <div class="timeline-details">
                <h3 class="timeline-title">{{ record.title }}</h3>

                <!-- Product Information -->
                <div class="product-info" *ngIf="record.product">
                    <span class="product-label">Product:</span>
                    <span class="product-name">{{ record.product.name }}</span>
                    <span class="separator">|</span>
                    <span class="quantity-label">Quantity:</span>
                    <span class="quantity-value">{{
                        record.product.quantity
                    }}</span>
                </div>
            </div>
        </div>
    </div>
</div>
